import { UserFormDataType } from './formData/types';
import { UserFormDataSchema } from './formData/UserFormDataSchema';
import { UserValidFormDataType } from './validFormData/types';
import { UserValidFormDataSchema } from './validFormData/UserValidFormDataSchema';
import { UserMutationDtoType } from './mutationDto/types';
import { UserMutationDtoSchema } from './mutationDto/UserMutationDtoSchema';

export class UserSchema {
  static parseFormData<Dto>(data: Dto): UserFormDataType {
    return UserFormDataSchema.parse(data);
  }

  static parseMutationDto<ValidFormData extends Partial<UserValidFormDataType>>(
    validFormData: ValidFormData
  ): UserMutationDtoType {
    return UserMutationDtoSchema.parse(validFormData);
  }

  static validFormDataSchema = UserValidFormDataSchema;
}
